<template>
  <div class="demo-app">
    <SchedulerCalendar
      :filter="filter"
      :active-tab="0"
      :is-home-view="true"
      :show-for-me-filter="true"
      :user="user"
    />
  </div>
</template>

<script>
import SchedulerCalendar from '@/views/scheduler/SchedulerCalendar.vue'
import { getUser } from '@/auth/utils'

export default {
  name: 'Home',
  components: {
    SchedulerCalendar,
  },
  data() {
    return {
      user: getUser(),
      filter: {
        currentPage: 1,
        courseId: '',
        courseSemesterId: '',
        teacherId: '',
      },
    }
  },
}
</script>
